<script>
import { useHarbourStore } from '@/stores/harbour-store';
import translations from '@/utils/translations/translations';

export default {
  name: 'HrbrReviewAgreement',

  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Please review the document',
    },
  },

  data() {
    return {
      translations,
    };
  },

  setup() {
    const harbourStore = useHarbourStore();
    return {
      harbourStore,
    };
  },

  methods: {
    editClickHandler() {
      this.$emit('edit-text');
    },
    viewDocumentClickHandler() {
      this.$emit('view-document');
    },
  },
};
</script>

<template>
  <div
    class="review-document review-document-component review-document--first-review"
    @click="viewDocumentClickHandler">
    <i class="review-document__icon fa-light fa-file-pdf"></i>
    <div class="review-document__text" :style="{ display: 'flex', alignItems: 'center' }">
      {{ text }}
      <i
        v-if="editMode"
        @click.stop="editClickHandler"
        class="fal fa-pen editTitleHint"
        :style="{ marginLeft: '10px' }"></i>
    </div>
    <div class="review-document__btn">{{ translations.viewDocument[harbourStore.lang] }}</div>
  </div>
</template>

<style></style>
